<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {
	}
}

</script>

<style lang="scss">
@import '~scss_vars';

body {
	margin: 0px;
	padding: 0px;
	/*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
	// background: #1F2D3D;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;

	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.custom-dialog {

	.el-dialog__body {
		padding: 0px 20px;
	}

	.el-form--label-top .el-form-item__label {
		padding: 0;
	}

	.pic-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
	}

	.pic-uploader-pic {
		width: 178px;
		object-fit: contain;
		text-align: center;
		cursor: pointer;
	}

	.el-select,
	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}
}

.custom-form-inline {
	.el-form-item__content {
		display: flex;
		align-items: center;
		flex-flow: wrap;

		.el-form-item__error {
			width: 100%;
		}
	}

	.el-input {
		width: calc(100% - 132px);

		.el-input__inner {
			padding-left: 16px;
		}
	}

	.el-button {
		width: 112px;
		// height: 48px;
		// background: #0B6BBD;
		border: none;
		border-radius: 8px;
		margin-left: 10px;
	}

	.countDown {
		width: 112px;
		height: 30px;
		background: #EEEEEE;
		border-radius: 8px;
		line-height: 30px;
		text-align: center;
		font-size: 14px;
		color: #8E8E8E;
		margin-left: 10px;
		cursor: not-allowed;
	}
}

.el-table .el-table__cell {
	text-align: center !important;
}

.downloadFile {
	color: $color-primary;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// App.vue?6bbf02e7